export default __webpack_public_path__ + "static/media/illustration_detective.718b016e.png";